/**
 * Après un retour de recherche AutoComplete, faut-il ouvrir (ou garder) le dropdown.
 * BL-0367 : ne pas réouvrir la liste si le focus a déjà quitté l’input (Tab),
 * même si un timeout de blur est encore en cours.
 *
 * Faux blur (Tailwind 4) : si l’input a repris le focus, ouvrir malgré `blurClosePending`.
 */
export type U2000ShouldOpenAutoCompleteResultsAfterSearchInput = {
  inputIsActive: boolean;
  blurClosePending: boolean;
};

export function u2000ShouldOpenAutoCompleteResultsAfterSearch(
  input: U2000ShouldOpenAutoCompleteResultsAfterSearchInput,
): boolean {
  return input.inputIsActive;
}
